import React from "react";
import { CreditCardBackIcon } from "@bookingcom/bui-assets-react/streamline";
import { Banner, Link, Text } from "@bookingcom/bui-react";
import { useInstallmentsController } from "./useInstallments.controller.js";
export function Installments() {
    const { text, href, cta, pointOfSale } = useInstallmentsController();
    if (pointOfSale !== "br")
        return null;
    return (React.createElement(Banner, { dismissible: false, startIcon: CreditCardBackIcon },
        React.createElement(Text, { variant: "body_2" }, text),
        React.createElement(Link, { href: href, variant: "primary", attributes: { target: "_blank", rel: "noreferrer" } }, cta)));
}
